import { CSSProperties } from "react";

export interface Styles {
  sectionLabel: CSSProperties;
  title: CSSProperties;
  typeBadge: CSSProperties;
  thumb: CSSProperties;
  iconButton: CSSProperties;
}

const styles: Styles = {
  sectionLabel: {
    fontFamily: "var(--primary-font-semibold)",
    fontSize: 12,
    letterSpacing: "0.02em",
    color: "#1A1B22",
  },
  title: {
    fontFamily: "var(--primary-font-medium)",
  },
  typeBadge: {
    backgroundColor: "#F3F4F6",
    color: "#4b5563",
    fontFamily: "var(--primary-font-medium)",
    fontSize: 11,
  },
  // Banners are wide (16:5), so the thumbnail keeps that shape
  thumb: {
    width: 96,
    height: 30,
    objectFit: "cover",
  },
  iconButton: {
    color: "#6b7280",
  },
};

export default styles;
